import type { TrainingLocation } from '@/api/types/enrollment'

export function formatConfirmedStartDate(iso: string | null | undefined): string {
  if (!iso) return '—'

  const [year, month, day] = iso.split('-')
  if (!year || !month || !day) return iso

  const date = new Date(Number(year), Number(month) - 1, Number(day))
  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
}

export function findTrainingLocation(
  locations: TrainingLocation[],
  locationExternalId: string | null | undefined
) {
  if (!locationExternalId) return null

  return (
    locations.find(
      location =>
        location.externalId === locationExternalId ||
        String(location.id) === locationExternalId
    ) ?? null
  )
}

export function formatTrainingLocation(
  location: TrainingLocation | null,
  locationName: string | null | undefined
) {
  const displayName = location?.name?.trim() || locationName?.trim()
  if (!displayName) return '—'

  const cityState = [location?.city, location?.state]
    .map(value => value?.trim())
    .filter(Boolean)
    .join(', ')

  if (!cityState || displayName.includes(cityState)) {
    return displayName
  }

  return `${displayName}\n${cityState}`
}
